import { useTaskStates } from "../api/queries/useTaskStates"
import { MultiSelect } from "primereact/multiselect"

export default function TaskStateMultiFilter(props) {
  const { data: taskStates = [] } = useTaskStates()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={taskStates}
      optionLabel={"name"}
      optionValue={"value"}
      placeholder={"Stav"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
